import { Controller } from "@hotwired/stimulus"

// The Missions Planning modal's in-place task list (card #3593): the dashed
// "Add a reportable task" card reveals every task on the mission, with Tracked
// and Report toggles, right under the result cards they change.
//
// Not the shared collapse controller: the toggle button lives inside the
// result grid, which each toggle's turbo stream re-renders. A freshly rendered
// button would come back announcing aria-expanded="false" while the list is
// still open. toggleTargetConnected re-syncs it from the list's real state, so
// the button stays truthful across stream replacements.
export default class extends Controller {
  static targets = ["list", "toggle"]

  toggle() {
    this.listTarget.classList.toggle("hidden")
    this.sync()
    if (this.open) this.listTarget.scrollIntoView({ block: "nearest", behavior: "smooth" })
  }

  toggleTargetConnected() {
    this.sync()
  }

  get open() {
    return this.hasListTarget && !this.listTarget.classList.contains("hidden")
  }

  sync() {
    const open = String(this.open)
    this.toggleTargets.forEach((button) => button.setAttribute("aria-expanded", open))
  }
}
